import React from "react";
import { Routes, Route } from "react-router-dom";
import { useThemeInitializer, useLanguageInitializer, useSendHeightToParent, useReceiveDepositStatusRedirect } from "src/hooks";
import { Deposit, Withdrawal, NotFound, DepositStatus, PaymentRedirect } from "src/pages";
import { DepositWithdrawalShared } from "src/components";
import { ERoutes } from "src/types";

const Router: React.FC = (): JSX.Element => {
  useThemeInitializer();
  useLanguageInitializer();
  useSendHeightToParent();
  useReceiveDepositStatusRedirect();

  return (
    <>
      <Routes>
        <Route element={<DepositWithdrawalShared />}>
          <Route path={ERoutes.Deposit} element={<Deposit />} />

          <Route path={ERoutes.Withdrawal} element={<Withdrawal />} />
        </Route>

        <Route path={ERoutes.DepositStatus} element={<DepositStatus />} />

        <Route path={ERoutes.PaymentRedirect} element={<PaymentRedirect />} />

        <Route path={ERoutes.NotFound} element={<NotFound />} />
      </Routes>
    </>
  );
};

export default Router;
